import styled from "@emotion/styled";
import Image from 'gatsby-image';
import React from "react";
import { Cell, Row, Spacer100 } from '../grid/grid.component';
import { responsiveFont, settings } from '../grid/settings';
import { external_link } from '../grid/typography.component';

class ProductSpecs extends React.Component {

  renderTableRow(key, i, item, k) {
    return <div className="flex-row" key={`product-specs-${i}-${key}-${k}`}>{item.array[i]}</div>
  }
  renderTable(count, array, key) {
    let html = [];
    for (var i = 0; i < count; i++) {
      let opt = array.map(this.renderTableRow.bind(this, key, i));
      opt.unshift(<div className="flex-row hide-on-mobile" key={`product-specs-${i}-${key}-unshift`}></div>);
      html.push(<div className={`flex-table row ${`cols-` + array.length}`} key={`product-specs-${i}-${key}-push`}>{opt}</div>);
    }
    return html;
  }
  renderTableHeaders(array, key) {
    let html = [];
    for (var i = 0; i < 3; i++) {
      const text = array[i] ? array[i].area : '';
      html.push(<div className="flex-row faded" key={`product-specs-header-${key}-${i}`}>{text}</div>);
    }
    return html;
  }
  render() {
    const { width, height, depth, technical_drawing_horizontal, technical_drawing_vertical, materials, materialscount, colorscount, colors } = this.props;
    return (
      <ProductSpecsWrapper>
        <Row>
          <Cell.x2 className="hide-on-mobile" />
          <Cell>
            <Image {...technical_drawing_horizontal} className="hide-on-mobile" />
            <Image {...technical_drawing_vertical} className="show-on-mobile" />
          </Cell>
          <Cell.x2 className="hide-on-mobile" />
        </Row>
        <Spacer100 />
        <Row>
          <Cell.x1 className="hide-on-mobile" />
          <Cell>


            <p className="show-on-mobile">Dimensions</p>

            <SpecTable className="table-container" role="table" aria-label="Destinations">
              <div className="flex-table header">
                <div className="flex-row hide-on-mobile">Dimensions</div>
                <div className="flex-row faded">Height</div>
                <div className="flex-row faded">Width</div>
                <div className="flex-row faded">Depth</div>
              </div>
              <div className="flex-table row">
                <div className="flex-row hide-on-mobile">CM</div>
                <div className="flex-row">{height}</div>
                <div className="flex-row">{width}</div>
                <div className="flex-row">{depth}</div>
              </div>
            </SpecTable>


            <Spacer100 />

            <p className="show-on-mobile">Materials</p>
            <SpecTable className="table-container" role="table" aria-label="Destinations">
              <div className="flex-table header">
                <div className="flex-row hide-on-mobile">Materials</div>
                {this.renderTableHeaders(materials, 'areamaterials')}
              </div>
              {this.renderTable(materialscount, materials, 'materials')}
            </SpecTable>

            <Spacer100 />

            <p className="show-on-mobile">Colors</p>
            <SpecTable className="table-container" role="table" aria-label="Destinations">
              <div className="flex-table header">
                <div className="flex-row hide-on-mobile">Colors</div>
                {this.renderTableHeaders(colors, 'colors')}
              </div>
              {this.renderTable(colorscount, colors, 'colors')}
            </SpecTable>


            <Spacer100 />

            <a href="/" target="_blank" rel="noopener noreferrer" css={external_link}>request full package</a><br /><br /><br />
            <a href="/" target="_blank" rel="noopener noreferrer" css={external_link}>product fact sheet</a><br /><br /><br />
            <a href="/" target="_blank" rel="noopener noreferrer" css={external_link}>image bank</a><br /><br /><br />
            <a href="/" target="_blank" rel="noopener noreferrer" css={external_link}>request 3d files</a><br />
          </Cell>
          <Cell.x1 className="hide-on-mobile" />
        </Row >
      </ProductSpecsWrapper>
    )
  }
}

export default ProductSpecs



const border = '#DBD9CE';

const ProductSpecsWrapper = styled.div`
  overflow: hidden;
  text-transform: uppercase;
  letter-spacing: .17em;
  

  p{
    font-size: 12px;
    padding: 25px 0;
    margin: 0;
  }

  .show-on-mobile{
    display: block;
  }
  @media (min-width: ${settings.mobileWidth}px){
    .show-on-mobile{
      display: none;
    }
  }


  @media (max-width: ${settings.mobileWidth - 1}px){
    .hide-on-mobile{
      display: none;
    }
  }
`;


const SpecTable = styled.div`


  ${responsiveFont(settings.typo.specs)};
  .flex-table {
    display: flex;
  }

  .flex-row {
    width: 25%;
    padding: 25px 0;
    padding-right: 5px;
    border-bottom: solid 1px ${border};
  }

  .cols-2 .flex-row:last-of-type{
    width: 50%;
  }

  .faded{
    color: #6E6E6E;
  }

  @media (max-width: ${settings.mobileWidth - 1}px){
    .flex-row {
      width: 33%;
      padding: 17px 0;
    }
    .cols-2 .flex-row:last-of-type{
      width: 66%;
    }
  }
  

`;

